import { MBAnimation, MBAnimationProps } from './base';

export function MBAnimationFadeIn(props: MBAnimationProps) {
  return <MBAnimation opacity={{ from: 0, to: 1 }} {...props} />;
}
